<template>
  <div class="promotion-note">
    <p class="promotion-title">
      {{ $t('topUpPage.promotionTitle') }}
    </p>
    <p v-html="topUpPromoMessage" />
  </div>
</template>

<script>
export default {
  name: 'promotion-note',
  props: {
    topUpPromoMessage: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.promotion-note {
  background-color: $white;
  padding: 1.6rem;
  border-radius: 5px;
  font-size: 1.3rem;
  max-width: 36rem;

  .promotion-title {
    font-size: 1.8rem;
    font-weight: 600;
    background-image: linear-gradient(359deg, #b10d28, #cf1432 9%, #ed1a3b 25%, #f58220);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
